import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import school from 'api/school';
import courseItem from 'api/courseItemService';
import { getSchoolCourseID, getInfo, getFullDisplayInfo } from 'api/courseService';
// ----------------------------------------------------------------------

type SchoolCourseState = {
  // 课程信息
  info: {};
  // 全部班别
  class: {
    classTree: [];
    classList: [];
  };
  // 校本课程列表
  list: { total: number; rows: [] };
  // 课程id
  course_id: string;
  loading: boolean;
  // 完整课程信息
  full_info: { item: [] };
};

const initialState: SchoolCourseState = {
  info: {},
  class: {
    classTree: [],
    classList: []
  },
  list: { total: 0, rows: [] },
  course_id: '',
  loading: false,
  full_info: { item: [] }
};

const slice = createSlice({
  name: 'SchoolCourse',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    getClass(state, action) {
      state.class = action.payload;
    },
    getList(state, action) {
      state.loading = false;
      state.list = action.payload;
    },
    getCourseID(state, action) {
      state.course_id = action.payload;
    },
    getInfo(state, action) {
      state.info = action.payload;
    },
    getFullInfo(state, action) {
      state.full_info = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
export const { startLoading } = slice.actions;
// action
// 获取全部班别
export function getClassAction() {
  return () => {
    school
      .getClassTree()
      .then((ret) => {
        dispatch(
          slice.actions.getClass({
            classTree: ret.classTree,
            classList: ret.classList
          })
        );
      })
      .catch(() => {
        dispatch(
          slice.actions.getClass({
            classTree: [],
            classList: []
          })
        );
      });
  };
}
// 获取校本课程列表
export function getListAction({ id, grade = [], sort, order, is_cache, callback }: any) {
  return () => {
    dispatch(slice.actions.startLoading());
    courseItem
      .get_list(id, grade, 0, 9999, sort, order, is_cache)
      .catch((_err) => {
        dispatch(slice.actions.getList([]));
      })
      .then((ret) => {
        dispatch(slice.actions.getList(ret || { total: 0, rows: [] }));
      })
      .finally(() => {
        if (callback) callback();
      });
  };
}
// 获取校本课程id
export function getCoureIDAction(course_id = '') {
  return () => {
    if (course_id) {
      dispatch(slice.actions.getCourseID(course_id));
    } else {
      getSchoolCourseID()
        .then(({ display_id }) => {
          dispatch(slice.actions.getCourseID(display_id || ''));
        })
        .catch((_err) => {
          dispatch(slice.actions.getCourseID(''));
        });
    }
  };
}
// 获取课程信息
export function getInfoAction(id: string) {
  return () => {
    getInfo(id)
      .catch((_err) => {
        dispatch(slice.actions.getInfo({}));
        return null;
      })
      .then((ret) => {
        if (!!ret) {
          dispatch(slice.actions.getInfo(ret));
        }
      });
  };
}
export function getFullDisplayInfoAction(id: string) {
  return async () => {
    try {
      const result = await getFullDisplayInfo(id);
      dispatch(slice.actions.getFullInfo(result));
    } catch (error) {
      dispatch(slice.actions.getFullInfo({}));
    }
  };
}
